"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme,
  cssProps
}) => ({
  cursor: 'pointer',
  background: cssProps.active ? (0, _util.color)(theme, 'interactive.row.hover') : (0, _util.color)(theme, 'interactive.ui.default'),
  ':hover': {
    background: (0, _util.color)(theme, 'interactive.ui.hover')
  },
  ':active': {
    background: (0, _util.color)(theme, 'interactive.ui.active')
  }
});

exports.wrapper = wrapper;

const container = ({
  theme
}) => ({
  width: '100%',
  padding: (0, _util.spacing)(theme, ['large', 'xlarge']),
  cursor: 'pointer'
});

exports.container = container;
//# sourceMappingURL=CheckboxCard.style.js.map